import type { Prototype } from "../prototype-types";

export const peiranHongPrototypes: Prototype[] = [
  {
    id: "ph-faire-pay-popover-vs-dotted-tooltip",
    name: "Faire Pay Popover vs Dotted Tooltip",
    path: "/ph/faire-pay-popover-vs-dotted-tooltip",
    description:
      "Faire Pay account details mock testing whether Slate Popover (click) can replace DottedTooltip (hover) for stat labels",
    owner: "Peiran Hong",
    createdAt: "2026-08-21",
    lastUpdated: "2026-08-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/ed8fd7e422f90928e61feaea541ba74b39728914e5fba0afd005ac183a51699d.png",
    creationTool: "claude-code",
  },
];
